import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import Button from "../../components/ui/Button";
import { ApiConstants } from "../../constants/ApiConstants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { isDateFinalized } from "../../utils/Helper";

interface expensesFilterInputs {
    d_by?: object;
};

const MarkAsCompleted = ({ selectedChores, doneByOptions, expensesCategories, editChores, onSuccess, onCancel, finalizedMonths }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateChoresMarkAsComplete = useMakeRequest();

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<expensesFilterInputs>({
        mode: 'onChange',
    });

    useEffect(() => {
        const modal = document.getElementById("markAsCompletedModal");

        const handleBackdropClick = (e: any) => {
            if (e.target === modal) {
                $('.btn-close-modal').click();
            }
        };

        modal?.addEventListener("click", handleBackdropClick);

        return () => {
            modal?.removeEventListener("click", handleBackdropClick);
        };
    }, []);

    const onSubmit = (payload: any) => {
        console.log("profile?.uuid: ==", profile?.uuid)
        console.log("payload: ==", payload)


        const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
        if (is_finalized) {
            toast.error("Selected date already finalized.")
            return;
        }
        const updatedArray = editChores.map((item: any) => ({
            c_id: item?.c_id,
            is_deleted: 0,
            is_modified: item?.is_modified,
            m_date: item?.m_date,
            d_by: payload.d_by?.value || profile?.uuid,
            status: 3
        }));

        updateChoresMarkAsComplete.makeRequest({
            url: ApiConstants?.ChoresMarkAsComplete,
            payload: updatedArray
        });
    }

    useEffect(() => {
        if (updateChoresMarkAsComplete?.status) {
            onSuccess()
            toast.success("Chores updated successfully.")
            $('.btn-close-modal').click();
        }
    }, [updateChoresMarkAsComplete?.status])


    return (
        <div className="modal fade bottom-sheet-modal" id="markAsCompletedModal" tabIndex={-1} aria-labelledby="markAsCompletedModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="markAsCompletedModalLabel">Mark as Completed</h1>
                    </div>

                    <div className="modal-body">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
                            <div className="col-12 mb-5">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Member</label>
                                    <div className="custom-select">
                                        <ReactSelect
                                            options={doneByOptions}
                                            value={watch('d_by')}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Select Member"
                                            isLoading={expensesCategories?.loading}
                                            onChange={(selectedOption: any) => {
                                                setValue("d_by", selectedOption);
                                                trigger("d_by");
                                            }}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex gap-3 mt-4'>
                                <button
                                    className='custom-grayed-btn modal-light-btn btn-close-modal'
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    disabled={updateChoresMarkAsComplete?.loading}
                                    type="button"
                                    onClick={onCancel}
                                    style={{ width: "50%" }}
                                >
                                    Cancel
                                </button>
                                <Button
                                    className='com-btn'
                                    type="submit"
                                    text="submit"
                                    loading={updateChoresMarkAsComplete?.loading}
                                    style={{ width: "50%" }}
                                >
                                    Save
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarkAsCompleted

// import { useContext, useEffect } from "react";
// import { useForm } from "react-hook-form";
// import toast from "react-hot-toast";
// import ReactSelect from "react-select";
// import Button from "../../components/ui/Button";
// import { ApiConstants } from "../../constants/ApiConstants";
// import authContext from "../../context/authContext";
// import useMakeRequest from "../../utils/ApiHelper";
// import { isDateFinalized } from "../../utils/Helper";

// interface expensesFilterInputs {
//     d_by?: object; // Done by id
// };

// const MarkAsCompleted = ({ selectedChores, doneByOptions, expensesCategories, editChores, onSuccess, onCancel, finalizedMonths }: any) => {

//     let profile: any = useContext(authContext);
//     profile = profile?.data;
//     const updateChoresMarkAsComplete = useMakeRequest();


//     const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<expensesFilterInputs>({
//         mode: 'onChange',
//         // resolver: yupResolver(yup.object().shape({
//         //     h_spent: yup
//         //         .string()
//         //         .test(
//         //             'h_spent-required',
//         //             ValidationMessage.Field("a value greater than 0"),
//         //             function (value: any) {
//         //                 const { h_spent } = this.parent;
//         //                 if (Number(h_spent) === 0) return false;
//         //                 return true;
//         //             }
//         //         )
//         // })) as any
//     });

//     useEffect(() => {
//         if (editChores && doneByOptions?.length > 0) {

//             setValue('d_by', {
//                 value: editChores?.done_by?.value,
//                 label: profile?.uuid === editChores?.done_by?.value ? 'Me' : editChores?.done_by?.label
//             })

//         }
//     }, [editChores, doneByOptions, expensesCategories])

//     const onSubmit = (payload: any) => {
//         console.log("payload: ==", payload)

//         $('.btn-close-modal').click();
//         const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
//         if (is_finalized) {
//             toast.error("Selected date already finalized.")
//             return;
//         }

//         const updatedArray = editChores.map((item: any) => ({
//             c_id: item?.c_id,
//             is_deleted: 0,
//             is_modified: item?.is_modified,
//             d_by: payload.d_by?.value || profile?.uuid,
//             status: 3
//         }));

//         updateChoresMarkAsComplete.makeRequest({
//             url: ApiConstants?.ChoresMarkAsComplete,
//             payload: updatedArray
//         });
//     }

//     useEffect(() => {
//         if (updateChoresMarkAsComplete?.status) {
//             onSuccess()
//             toast.success("Chores updated successfully.")
//             $('.btn-close-modal').click();
//         }
//     }, [updateChoresMarkAsComplete?.status])

//     return (
//         <div className="modal fade inner-modal com-modal" id="markAsCompletedModal" tabIndex={-1} aria-labelledby="markAsCompletedModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
//             <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
//                 <div className="modal-content">
//                     <div className="modal-header">
//                         <h1 className="modal-title" id="markAsCompletedModalLabel">Mark as Completed</h1>
//                     </div>
//                     <div className="modal-body">
//                         <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label d-block">Member</label>
//                                     <div className="custom-select">
//                                         <ReactSelect
//                                             options={doneByOptions}
//                                             value={watch('d_by')}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Select Member"
//                                             isLoading={expensesCategories?.loading}
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("d_by", selectedOption);
//                                                 trigger("d_by");
//                                             }}
//                                             menuPortalTarget={document.body}
//                                             styles={{
//                                                 menuPortal: base => ({ ...base, zIndex: 9999 })
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className='page-padding-x pb-4 d-flex'>
//                                 <Button className='com-btn mt-2 me-4' style={{ width: "50%" }} type="submit" text="submit" loading={updateChoresMarkAsComplete?.loading}>Save</Button>
//                                 <button className='com-btn com-btn-outline mt-2  btn-close-modal' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateChoresMarkAsComplete?.loading} type="button" onClick={onCancel}>Cancel</button>
//                             </div>
//                         </form>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default MarkAsCompleted